import { IGetIndicadorDropDownUseCase } from "../../../presentation/useCases/read/get_indicador_drop_down_use_case";
import { IndicadorDropDown } from "../../models/indicador_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetIndicadorDropDownUseCase
 */

export class GetIndicadorDropDownUseCase implements IGetIndicadorDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getIndicadorDropdown(
    idObra: number | undefined,
  ): Promise<IndicadorDropDown[]> {
    if (idObra === undefined) throw new Error('id de obra invalido!');
    return await this.repository.getIndicadorDropdown(idObra);
  }
}
